var _path, _line, _line2, _line3, _line4, _line5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSquareAreaBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1667 2H3.83333C3.09695 2 2.5 2.59695 2.5 3.33333V12.6667C2.5 13.403 3.09695 14 3.83333 14H13.1667C13.903 14 14.5 13.403 14.5 12.6667V3.33333C14.5 2.59695 13.903 2 13.1667 2Z",
    stroke: "#464649",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 2.45724,
    y1: 10.0254,
    x2: 10.4358,
    y2: 2.04676,
    stroke: "#464649"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 3.25338,
    y1: 13.4726,
    x2: 14.2135,
    y2: 2.51246,
    stroke: "#464649"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 7.06197,
    y1: 13.9062,
    x2: 14.5217,
    y2: 6.44644,
    stroke: "#464649"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 11.3264,
    y1: 13.8847,
    x2: 14.4048,
    y2: 10.8063,
    stroke: "#464649"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 2.33614,
    y1: 5.90426,
    x2: 6.25501,
    y2: 1.98539,
    stroke: "#464649"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareAreaBlack);
export default __webpack_public_path__ + "static/media/square-area-black.838c1e9da177e581a18e29c8a4bfeeb8.svg";
export { ForwardRef as ReactComponent };